import localeAntd from 'ant-design-vue/lib/locale-provider/fr_FR';

const messages = {
  topBar: {
    profileMenu: {
      hello: 'Bonjour',
      editProfile: 'Editer le profil',
      settings: 'Paramètres',
      logout: 'Se déconnecter',
    },
  },
  menuLeft: {
    top: {
      churchDashboard: "Tableau de bord de l'église",
    },
    user: {
      churchPartner: "Partenaire de l'église",
      evangelismPartner: "Partenaire d'évangélisation",
    },
    menu: {
      account: 'Compte',
      dashboard: 'Tableau de bord',
      profile: 'Profil',
      viewProfile: 'Voir le profil',
      editProfile: 'Editer le profil',
      profileVideo: 'Vidéo',
      orderCards: "Commander des cartes d'invitation",
      evangelismBootcamp: "Camp d'entraînement sur l'évangélisation",
      shareStory: 'Partagez mon histoire de Jésus',
      messages: 'messages',
      trackProgress: 'Suivez vos progrès',
      studyGuides: "Guides d'étude",
      bulletinInsert: 'Encarts de bulletins',
      resources: 'Ressources',
      monthlyVideos: 'Vidéos mensuelles',
      videoPlayer: 'Lecteur vidéo',
      campuses: "Adresse de recherche d'église",
      AccountInvoicePayment: 'Factures de compte',
      updateBillingInfo: 'Informations de paiement',
      paymentInfo: 'Informations de paiement',
      supportCenter: 'Centre de soutien',
      churchProfile: "Profil de l'église",
      churchAccess: "Accès à l'église",
      testimonials: 'Témoignages',
      welcomeVideo: "Vidéo d'invitation",
    },
  },
  pricing: {
    getPricing: 'OBTENIR LES PRIX',
    title: 'Pour voir les prix et vous inscrire, sélectionnez la fréquentation moyenne de votre église',
    buttonSelectAbove: 'SÉLECTIONNER CI-DESSUS',
    monthlyPlan: 'Plan mensuel',
    monthlyPlanSub: '(12 paiements requis)',
    buttonJoinMonthly: 'Rejoindre le forfait mensuel',
    yearlyPlan: 'Plan annuel',
    yearlyPlanSub: '(économisez 16%)',
    buttonJoinYearly: 'Rejoindre le plan annuel',
    multipleDesign3: 'Trois',
    multipleDesign2: 'Deux',
    multipleDesign1: 'Un',
    errorCard: {
      title: 'Les champs suivants semblent invalides:',
      number: 'numéro de carte',
      month: 'mois',
      year: 'année',
      first_name: 'prénom',
      last_name: 'nom de famille',
    },
    feature: {
      para0: {
        title: "—- cartes d'invitation vidéo de pasteur de code QR conçues sur mesure",
        content: "Cartes d'invitation vidéo de pasteur de code QR conçues sur mesure",
      },
      para1: {
        title: "Licence d'un an pour utiliser TrueLife.org",
        content: "Licence d'un an pour utiliser TrueLife.org",
      },
      para2: {
        title: "Majorité de l'église invitant",
        content: "Majorité de l'église invitant",
      },
      para3: {
        title: 'Accès au système de localisation des églises True Life',
        content: 'Accès au système de localisation des églises True Life',
      },
      para4: {
        title: "Connectez les histoires de Jésus au profil de l'église",
        content: "Connectez les histoires de Jésus au profil de l'église",
      },
      para5: {
        title: "Guides d'étude et guides de l'animateur",
        content: "Guides d'étude et guides de l'animateur",
      },
      para6: {
        title: "Boot Camp d'évangélisation et guides des leaders",
        content: "Boot Camp d'évangélisation et guides des leaders",
      },
      para7: {
        title: 'Lecteur vidéo pour votre site Web',
        content: 'Lecteur vidéo pour votre site Web',
      },
    },
    guarantees: {
      para1: 'Au-delà des garanties',
      para2: "S'il y a JAMAIS une vidéo ou un article TrueLife.org avec lequel l'église n'est pas d'accord, vous obtenez un remboursement complet.",
      para3: "Si votre direction dit non après avoir regardé la vidéo d'introduction et avant que nous concevions vos cartes d'invitation et les imprimions, vous obtenez un remboursement complet.",
      para4: 'Vous avez 30 jours avec les cartes pour suivre notre stratégie. ',
    },
  },
  page: {
    dashboardIndividual: {
      introduction: "Nous sommes ravis de vous aider à partager votre histoire de Jésus!<br/>Commencez par regarder la vidéo d'introduction!",
    },
    dashboard: {
      getMostFromTruelife: {
        para1: 'Exemple de verbiage pour la fin du service pour les amener à prier sur leurs cartes',
        para2: "Frères et sœurs, aujourd'hui vous avez entendu le message et l'Evangile. ",
        para3: "* S'il vous plaît, ne travaillez jamais si dur sur votre sermon et ne fermez pas votre message sans dire quelque chose comme ça. ",
      },
      churchTraningVideo: {
        para1: "Cliquez pour télécharger la vidéo d'introduction",
      },
      videoShareWithChuch: {
        para1: "Cliquez pour télécharger la vidéo d'introduction",
      },
      getWeeklyResults: {
        para1: 'Découvrez comment obtenir des résultats chaque semaine dans cette vidéo de 2 minutes.',
      },
      accountPaymentDate: {
        para1: 'Date de renouvellement annuel du compte',
      },
      recentUpdate: {
        para1: "Nous avons récemment mis à jour nos conditions d'utilisation et notre politique de confidentialité. ",
        link: 'ici',
      },
      whyYouShouldUpgrade: {
        para1: 'Cliquez pour mettre à niveau',
      },
    },
    orderCards: {
      instructionsResources: {
        para1: "Remplissez le formulaire sur cette page pour commander vos cartes d'invitation sur TrueLife.org. ",
      },
      reOrderingInstructions: {
        para1: 'Si vous avez besoin de passer une nouvelle commande de cartes, veuillez utiliser notre formulaire de nouvelle commande.',
        link: 'Cliquez ici',
      },
    },
    trackProgress: {
      submitTrackYourProgress: {
        para1: 'Remplissez le formulaire sur cette page pour suivre vos progrès auprès de notre équipe de service client.',
      },
    },
    bulletinInserts: {
      bulletinInserts: {
        para1: 'Téléchargez des encarts préconçus pour votre bulletin.',
        link: "Trousse d'insertion de bulletin",
        para2: 'Inclus dans le kit',
      },
    },
    videoPlayer: {
      videoPlayerForYourChurchWebsite: {
        para1: "Première étape: Entrez l'URL du site Web de votre église (exemple: www.mychurch.com)",
        para2: "Deuxième étape: choisissez les catégories à inclure dans le lecteur (ou cliquez simplement sur Générer le code d'intégration pour inclure toutes les catégories)",
        para3: "Ajouter un bouton de don: entrez l'URL de votre page de don",
      },
    },
    campuses: {
      para1: 'Veuillez ajouter les emplacements des campus de votre église.',
      para2: "Si vous n'avez qu'un seul emplacement, veuillez laisser le nom tel quel. ",
      para3: "Exemple : Nom de l'église - Nom du campus",
      yourLocations: {
        para1: "Veuillez ajouter un campus d'église",
      },
    },
    dashboardCare: {
      howToSetupYourChurchProfile: {
        para1: "Sur le côté gauche, vous verrez à la fois le profil de l'église et les éléments du menu d'accès à l'église. ",
      },
      howToDirectChurchMembersToTruelifeCare: {
        para1:
          'Pour diriger les membres de votre église vers TrueLifeCare.org, veuillez utiliser les encarts de bulletin ou les images de projecteur fournis dans le tableau de bord de votre église. ',
      },
      whyYouShouldIncludeAPersonalVideoFromThePastor: {
        para1: 'Avoir une vidéo personnelle de votre pasteur aide vos membres à se sentir acceptés, aimés et compris par votre église. ',
      },
      howToUseTruelifeCareInCounselingSessions: {
        para1: 'TrueLifeCare.org est conçu pour que vous puissiez utiliser ces ressources lors de vos séances de conseil. ',
      },
      evangelismProgram: {
        para1: "Cliquez pour en savoir plus sur l'évangélisation TrueLife.org",
      },
    },
    churchAccess: {
      churchMembersAccessCredentials: {
        para1: 'Configurez les informations de connexion que vous partagerez avec les membres de votre église. ',
      },
    },
    account: {
      churchMembershipInformation: {
        para1: 'Prochaine date de renouvellement du compte',
      },
    },
    support: {
      submitASupportRequest: {
        para1: "Remplissez le formulaire sur cette page pour demander l'assistance de notre équipe de service client.",
      },
    },
    updateBilling: {
      para1: 'Votre compte a une facture ouverte, veuillez mettre à jour les détails de votre carte',
    },
    welcomeVideo: {
      step1: 'Enregistrez votre vidéo de bienvenue',
      step2: 'Choisissez votre URL personnalisée',
      step3: 'Confirmation!',
      step4: 'Il est maintenant temps de connecter votre église !',
    },
    shareYourStory: {
      step1: 'Enregistrez votre histoire',
      step2: 'Choisissez votre URL personnalisée',
      step3: 'Confirmation!',
      step4: 'Il est maintenant temps de connecter votre église !',
    },
  },
  cardTitle: {
    yourTestimonials: 'Vos témoignages',
    shareYourStory: 'Partagez votre histoire',
    welcomeVideo: 'Vidéo de bienvenue du pasteur',
    accountPaymentDate: 'Date de paiement du compte',
    memberDashboardIntro: 'Présentation du tableau de bord des membres',
    churchTraningVideo: "Vidéo de formation sur les cartes d'invitation",
    videoShareWithChuch: "Vidéo de formation sur l'histoire de Jésus",
    jesusStoryChurchPayingVideo: "Bonus: vidéo de formation sur les cartes d'invitation",
    whyYouShouldUpgrade: 'Pourquoi devriez-vous mettre à niveau!',
    getMostFromTruelife: 'Utilisez et configurez facilement les histoires de Jésus de votre église',
    getWeeklyResults: 'Obtenez des résultats hebdomadaires',
    recentUpdate: 'Mise à jour récente',
    howToEditChurchProfile: "Comment modifier le profil de l'église",
    editYourChurchProfile: "Modifier votre profil d'église",
    editChurchProfile: "Modifier le profil de l'église",
    howToOrderCards: 'Comment commander des cartes',
    cardOrderForm: 'Formulaire de commande de carte',
    instructionsResources: 'Instructions',
    reOrderingInstructions: 'Instructions de réapprovisionnement',
    messageFromTruelifeVisitor: 'Messages des visiteurs de TrueLife.org dans votre église',
    trackYourProgress: 'Suivez vos progrès',
    submitTrackYourProgress: 'Soumettre un suivi de vos progrès',
    studyGuides: "Guides d'étude",
    bulletinInserts: 'Encarts de bulletins',
    howToUseThisWizard: 'Comment utiliser cet assistant',
    videoPlayerForYourChurchWebsite: 'Lecteur vidéo pour le site Web de votre église',
    categorySpecificPlayers: 'Joueurs spécifiques à une catégorie',
    embedThisCodeInYourwebsite: 'Intégrez ce code dans votre site Web',
    previewVideoPlayer: 'Aperçu du lecteur vidéo',
    howToAddChurchLocation: "Comment ajouter l'emplacement de l'église",
    yourLocations: 'Vos emplacements',
    locations: 'Emplacements',
    addYourChurchLocation: "Ajoutez l'emplacement de votre église",
    howToSetupYourChurchProfile: 'Vidéo de présentation du tableau de bord',
    setupShareYourStory: "Invitez votre église au défi de l'histoire de Jésus!",
    uploadProfileVideo: 'Télécharger la vidéo de profil',
    howToDirectChurchMembersToTruelifeCare: "Comment diriger les membres de l'église vers TruelifeCare",
    whyYouShouldIncludeAPersonalVideoFromThePastor: 'Pourquoi devriez-vous inclure une vidéo personnelle du pasteur',
    howToUseTruelifeCareInCounselingSessions: 'Comment utiliser Truelife Care dans les séances de conseil',
    evangelismProgram: "Programme d'évangélisation",
    updateChurchProfile: "Mettre à jour le profil de l'église",
    churchMembersAccessCredentials: "Identifiants d'accès des membres de l'église",
    churchMembershipInformation: "Informations sur l'adhésion à l'église",
    invoices: 'Factures',
    transactions: 'Transactions',
    updateBillingInfo: 'Informations de paiement',
    supportRequest: 'Demande de soutien',
    submitASupportRequest: "Soumettre une demande d'assistance",
    specificCategoryEmbed: 'Intégrer une catégorie spécifique',
    churchLocation: {
      adminUpdate: "Mettre à jour l'emplacement de l'église",
      adminAdd: "Ajouter l'emplacement de l'église",
      update: "Mettez à jour l'emplacement de votre église",
      add: "Ajoutez l'emplacement de votre église",
    },
    socialMedia: 'Réseaux sociaux',
    mediaResources: 'Ressources médias',
    updateYourProfile: 'Mettre à jour votre profil',
    settings: 'Paramètres',
    connectToChurch: 'Dernière étape du défi: connectez votre église!',
  },
  button: {
    clear: 'Clair',
    download: 'Télécharger',
    video: 'Vidéo',
    downloadTrainngVideo: 'Télécharger la video',
    updateAccount: 'Compte mis à jour',
    copyToClipboard: 'Copier dans le presse-papier',
    back: 'Dos',
    nextSelectCategories: 'Suivant: Sélectionner les catégories',
    nextGenerateEmbedCode: "Suivant: Générer le code d'intégration",
    createLocation: 'Créer un emplacement',
    learnMore: 'Apprendre encore plus',
    updateSettings: 'Mettre à jour les paramètres',
    updateProfile: 'Mettre à jour le profil',
    updateUser: "Mettre à jour l'utilisateur",
    createUser: 'Créer un utilisateur',
    updateAnswer: 'Mettre à jour la réponse',
    createAnswer: 'Créer une réponse',
    updateCategory: 'Mettre à jour la catégorie',
    createCategory: 'Créer une catégorie',
    updateSpeakerBio: 'Mettre à jour la biographie du conférencier',
    createSpeakerBio: 'Créer une biographie de conférencier',
    updateLocation: "Mettre à jour l'emplacement",
    createSpecificCategoryEmbed: 'Créer une intégration de catégorie spécifique',
    save: 'Sauvegarder',
    submit: 'Soumettre',
    giveNow: 'Donne maintenant',
    upload: 'Télécharger',
    cancel: 'Annuler',
    continue: 'Continuer',
    socialMediaKit: 'Trousse de médias sociaux',
    mediaPackage: 'Forfait média',
    resetMyPassword: 'Réinitialiser mon mot de passe',
    goBack: ' Retourner',
    login: 'Connexion',
    signUp: "S'inscrire",
    yes: 'Oui',
    no: 'Non',
    edit: 'Modifier',
    delete: 'Supprimer',
    search: 'Recherche',
    reset: 'Réinitialiser',
    hidePreview: "Masquer l'aperçu",
    preview: 'Aperçu',
    accountDetails: 'Détails du compte',
    downloadCheatSheet: 'Télécharger la feuille de triche',
    readyToGo: 'Commencer!',
    startOver: 'Recommencer',
    uploadVideo: 'Télécharger une video',
    recordVideo: 'Enregistrer une vidéo',
    embedVideo: 'Intégrer la vidéo',
    redo: 'Refaire',
    keep: 'Donjon',
    redoAll: 'Tout refaire',
    keepAll: 'Sauver tous',
    redoTypeVideo: 'Refaire la vidéo {type}',
    takeThumbnail: 'Sélectionnez la vignette vidéo de la vidéo',
  },
  label: {
    churchDescription: "Description de l'église",
    videoEmbed: 'Intégrer la vidéo',
    serviceTimes: 'Horaires des services',
    contactDetails: 'Détails du contact',
    website: 'Site Internet',
    useWebsite: 'Utiliser le site Web du profil',
    phone: 'Numéro de téléphone',
    facebook: 'Facebook',
    twitter: 'Twitter',
    profileBannerPicture: 'Image de bannière de profil',
    pastorsHeadshot: 'Tête de pasteurs',
    viewMessage: 'Voir message',
    subject: 'Sujet',
    from: 'Depuis',
    yourDonationPageAddress: 'Adresse de votre page de don',
    createSpecificCategoryEmbed: 'Créer une intégration de catégorie spécifique',
    embedThisCodeInYourWebsite: 'Intégrez ce code dans votre site Web',
    name: 'Nom',
    address: 'Adresse',
    address2: 'Adresse 2',
    city: 'Ville',
    state: 'État',
    zipCode: 'Code postal',
    country: 'Pays',
    counselingPastor: 'Pasteur conseil',
    counselingContactEmail: 'Email de contact de conseil',
    churchAddress: "Adresse de l'église",
    churchPhone: "Téléphone de l'église",
    churchWebsite: "Site Web de l'église",
    welcomeVideoEmbedCode: "Vidéo de bienvenue - Code d'intégration",
    email: 'E-mail',
    password: 'Mot de passe',
    newPassword: 'Nouveau mot de passe',
    churchLoginDetail: "Détails de connexion de l'église",
    careLogin: 'Connexion aux soins',
    carePassword: "Mot de passe d'entretien",
    invoiceID: 'Numéro de facture',
    total: 'Total',
    download: 'Télécharger',
    downloadPDF: 'Télécharger le PDF',
    status: 'Statut',
    action: 'Action',
    amount: 'Montant',
    date: 'Date',
    invoice: 'Facture',
    description: 'Description',
    firstNameFirstHalfChurchName: "Prénom (ou premier nom de l'église)",
    lastNameSecondHalfChurchName: "Nom de famille (ou deuxième moitié du nom de l'église)",
    cardNumber: 'Numéro de carte',
    expirationDate: "Date d'expiration",
    CVV: 'CVV',
    pastorFirstName: 'Prénom du pasteur',
    pastorLastName: 'Nom de famille du pasteur',
    role: 'Rôle',
    cellPhone: 'Téléphone portable',
    churchName: "Nom de l'église",
    planInformation: 'Renseignements sur le régime',
    plan: 'Plan',
    price: 'Prix',
    errorAccountPlanInvalid: 'Compte et forfait invalides',
    errorAccountInvalid: 'Compte invalide',
    errorPlanInvalid: 'Plan invalide',
    selectFomGallery: "Sélectionnez l'image de couverture dans la galerie",
    uploading: 'Téléchargement',
    nextBillingDate: 'Prochaine date de facturation',
    contactSupport: 'Contactez le support',
    termsOfUse: "Conditions d'utilisation",
    support: 'Soutien',
    contacts: 'Contacts',
    areYouSure: 'Es-tu sûr?',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    search: 'Recherche',
    embedVideoUrl: "Intégrer l'URL de la vidéo:",
    pickCustomUrl: 'Choisissez votre URL personnalisée:',
    truelifeTypePage: 'Page Truelife {type}:',
    directConnectionLink: "Lien d'invitation du pasteur:",
    inviteModerator: 'Inviter des modérateurs',
    moderatorInvitationLink: "Lien d'invitation du modérateur:",
    somethingWentWrong: "Quelque chose s'est mal passé!",
    slugExists: 'Cette URL personnalisée existe déjà, veuillez en choisir une autre.',
    jesusStories: "Vidéos sur l'histoire de Jésus:",
    qrCode: 'QR Code',
    introVideoStatus: {
      created: "À l'étude",
      review: "À l'étude",
      approved: 'Approuvé',
      blocked: 'Bloqué',
      no_payment: 'Pas de paiement',
    },
    supportEmail: "E-mail d'assistance",
    designerEmail: 'Courriel du concepteur',
    welcomeInstructionLink: "Lien d'instruction de bienvenue (P)",
    shareStoryInstructionLink: "Lien d'instruction de l'histoire de Jésus (i)",
    mainDashboardVideoLink_p: 'Vidéo du tableau de bord principal (P)',
    mainDashboardVideoLink_i: 'Vidéo du tableau de bord Mani(i)',
    evangelismBootCampLink_p: "Vidéo du camp d'entraînement sur l'évangélisation (P)",
    evangelismBootCampLink_i: "Vidéo du camp d'entraînement sur l'évangélisation (i)",
    moderatorVideoLink: 'Vidéo du modérateur',
    individualSignupLink: 'Inscription individuelle',
    reminderStoryLink: "Rappel contextuel pour l'histoire",
    reminderWelcomeLink: 'Rappel contextuel de bienvenue',
    churchInvitationLink: "Vidéo d'invitation du pasteur",
    churchModeratorInvitationLink: "Vidéo d'invitation du modérateur",
  },
  placeholder: {
    pleaseInputTheLocationName: "Veuillez saisir le nom de l'emplacement!",
    pleaseInputYourAddress: 'Veuillez saisir votre adresse!',
    pleaseInputYourCity: 'Veuillez entrer votre ville!',
    pleaseInputYourState: 'Veuillez entrer votre état!',
    pleaseInputYourZipcode: 'Veuillez saisir votre code postal!',
    pleaseInputYourCountry: 'Veuillez entrer votre pays!',
    yourChurchWebsiteAddress: 'Adresse du site Web de votre église',
    yourDonationPageAddress: 'Adresse de votre page de don',
    pleaseInputPastorFirstName: 'Veuillez saisir le prénom du pasteur!',
    pleaseInputPastorLastName: 'Veuillez saisir le nom de famille du pasteur!',
    pleaseInputRole: 'Veuillez saisir votre rôle!',
    pleaseInputCellPhone: 'Veuillez saisir votre téléphone portable!',
    pleaseInputChurchName: 'Veuillez saisir le nom de votre église!',
    pleaseInputEmail: 'Veuillez saisir votre e-mail!',
    pleaseInputPassword: 'Veuillez saisir votre mot de passe!',
    pleaseInputCarePastor: 'Veuillez entrer Care Pastor!',
    pleaseInputCareEmail: "Veuillez saisir l'e-mail d'assistance!",
    pleaseInputCareAddress: "Veuillez entrer l'adresse de soins!",
    pleaseInputCarePhone: "Veuillez saisir le numéro de téléphone de l'assistance!",
    pleaseInputCareWebsite: 'Veuillez saisir le site Web de Care!',
    pleaseInputFirstName: 'Veuillez saisir le prénom!',
    pleaseInputLastName: 'Veuillez entrer le nom de famille!',
    pleaseInputCardNumber: 'Veuillez saisir le numéro de carte!',
    pleaseInputMonth: 'Veuillez saisir le mois!',
    pleaseInputYear: "Veuillez saisir l'année!",
    pleaseInputCVV: 'Veuillez saisir le CVV!',
    pleaseInputAddress: "Veuillez saisir l'adresse!",
    pleaseInputState: "Veuillez entrer l'état!",
    pleaseInputCity: 'Veuillez entrer la ville!',
    pleaseInputCountry: 'Veuillez saisir le pays!',
    pleaseInputChurchDescription: "Veuillez saisir la description de l'église!",
    pleaseInputContactDetails: 'Veuillez saisir les coordonnées!',
    pleaseInputTitle: 'Veuillez entrer le titre!',
    pleaseInputSlug: 'Veuillez saisir slug!',
    pleaseInputDescription: 'Veuillez saisir une description!',
    pleaseSelectAnswerType: 'Veuillez sélectionner le type de réponse!',
  },
};

export default {
  locale: 'es',
  localeAntd,
  messages,
};
